import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { AppButton } from '../../../../client/components/atom/app-button/app-button';
import { ScrollService } from '../../../../../shared/services/scroll.service';

@Component({
  selector: 'app-process-section',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    TranslatePipe,
    AppButton
  ],
  templateUrl: './process-section.html',
  styleUrl: './process-section.scss'
})
export class ProcessSection {
  constructor(private scrollService: ScrollService) {}
}
